import type { IconData } from '@stacksjs/iconify-core'

export const basicUiDelete: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 4l4-4l4 4l4-4l4 4l-4 4l4 4l-4 4l-4-4l-4 4l-4-4l4-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiDelete
